import React from "react";
import { Link } from "react-router-dom";
import ArsenHeroSVG from "../../component/SVGs/ArsenHeroSVG";

const badges = [
  { label: "Hybrid" },
  { label: "Hadiah Jutaan Rupiah" },
  { label: "SMA & Mahasiswa se-Indonesia" },
];

const activities = [
  {
    slug: "opening",
    name: "Opening",
    label: "Ceremony · Talkshow",
    description: "Pembuka rangkaian ARSEN 2026 dengan talkshow inspiratif seputar data dan statistika.",
    color: "arsen-quaternary",
    border: "border-arsen-quaternary-950",
    tag: "bg-arsen-quaternary-100 text-arsen-quaternary-950",
    cta: "text-arsen-quaternary-950 hover:bg-arsen-quaternary-950",
  },
  {
    slug: "asic",
    name: "ASIC Siswa",
    label: "Infographic · SMA/Sederajat",
    description: "Kompetisi infografis nasional untuk siswa SMA/sederajat.",
    color: "arsen-primary",
    border: "border-arsen-primary",
    tag: "bg-arsen-primary-50 text-arsen-primary",
    cta: "text-arsen-primary hover:bg-arsen-primary",
  },
  {
    slug: "asic/mahasiswa",
    name: "ASIC Mahasiswa",
    label: "Infographic · Mahasiswa",
    description: "Kompetisi infografis nasional untuk mahasiswa perguruan tinggi.",
    color: "arsen-primary",
    border: "border-arsen-primary-800",
    tag: "bg-arsen-primary-100 text-arsen-primary-800",
    cta: "text-arsen-primary-800 hover:bg-arsen-primary-800",
  },
  {
    slug: "asec",
    name: "ASEC",
    label: "Essay · Mahasiswa",
    description: "Kompetisi esai berbasis statistika untuk mahasiswa se-Indonesia.",
    color: "arsen-secondary",
    border: "border-arsen-secondary",
    tag: "bg-arsen-secondary-50 text-arsen-secondary",
    cta: "text-arsen-secondary hover:bg-arsen-secondary",
  },
  {
    slug: "aso",
    name: "ASO",
    label: "Olympiad · SMA/Sederajat",
    description: "Olimpiade statistika bergengsi untuk siswa SMA/sederajat.",
    color: "arsen-tertiary",
    border: "border-arsen-tertiary",
    tag: "bg-arsen-tertiary-50 text-arsen-tertiary",
    cta: "text-arsen-tertiary hover:bg-arsen-tertiary",
  },
];

const goals = [
  "Meningkatkan kesadaran generasi muda akan pentingnya data dan statistika dalam membangun komunitas berkelanjutan dan kota yang berkeadilan.",
  "Mendorong kolaborasi dan kerja tim antara mahasiswa statistika.",
  "Memperluas pembelajaran dan pengetahuan tentang statistika.",
  "Mendorong kompetisi yang sehat di antara peserta kegiatan.",
  "Mengembangkan kreativitas dalam menerapkan metode statistika.",
];

function Home() {

  return (
    <div className="flex flex-col">
      {/* ── HERO ── */}
      <section className="relative overflow-hidden bg-gradient-to-br from-white via-arsen-primary-50 to-arsen-sky-50 pt-12 pb-20 px-5 sm:px-8">
        {/* Background decoration */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-arsen-primary-100 rounded-full opacity-30 blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-arsen-sky-100 rounded-full opacity-40 blur-2xl translate-y-1/3 -translate-x-1/4 pointer-events-none" />

        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">
          {/* Left copy */}
          <div className="flex-1 flex flex-col gap-6 text-center md:text-left z-10">
            {/* Badge */}
            <div data-aos="fade-up">
              <span className="inline-block px-4 py-1.5 rounded-full bg-arsen-primary-50 border border-arsen-primary-200 text-arsen-primary text-xs font-bold tracking-widest uppercase">
                ARSEN · 2026
              </span>
            </div>

            {/* Heading */}
            <h1
              data-aos="fade-up"
              data-aos-delay="80"
              className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-arsen-quaternary-950 leading-tight tracking-tight"
            >
              Airlangga <span className="text-arsen-primary">Statistics</span>{" "}
              Events
            </h1>

            {/* Tagline */}
            <p
              data-aos="fade-up"
              data-aos-delay="160"
              className="text-base sm:text-lg text-gray-500 leading-relaxed max-w-lg mx-auto md:mx-0"
            >
              Defining Certainty within Global Volatility by Unlocking the
              Trivecta of Data Mastery
            </p>

            {/* CTAs */}
            <div
              data-aos="fade-up"
              data-aos-delay="240"
              className="flex flex-col sm:flex-row gap-3 justify-center md:justify-start"
            >
              <Link
                to="/events"
                onClick={() => window.scrollTo(0, 0)}
                className="px-8 py-3 rounded-xl bg-arsen-primary text-white font-semibold text-sm hover:bg-arsen-primary-600 hover:shadow-lg transition-all duration-200 text-center"
              >
                Lihat Kegiatan
              </Link>
              <a
                href="#tentang"
                className="px-8 py-3 rounded-xl border border-gray-200 text-gray-600 font-semibold text-sm hover:border-arsen-primary hover:text-arsen-primary transition-all duration-200 text-center"
              >
                Pelajari Lebih Lanjut
              </a>
            </div>

            {/* Feature badges */}
            <div
              data-aos="fade-up"
              data-aos-delay="320"
              className="flex flex-wrap gap-2 justify-center md:justify-start"
            >
              {badges.map((b) => (
                <span
                  key={b.label}
                  className="flex items-center gap-1.5 text-xs font-medium text-gray-500 bg-white border border-gray-200 px-3 py-1.5 rounded-full"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-arsen-primary inline-block" />
                  {b.label}
                </span>
              ))}
            </div>

            {/* Powered by Indolat */}
            <a
              data-aos="fade-up"
              data-aos-delay="400"
              href="https://indolat.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 self-center md:self-start bg-white/80 backdrop-blur border border-gray-200 rounded-xl px-4 py-2.5 hover:border-orange-300 hover:shadow-md transition-all duration-200"
            >
              <img
                src="/assets/img/logo/indolat-mark.webp"
                alt="Indolat"
                className="w-12 h-12 object-contain"
              />
              <span className="flex flex-col text-left leading-tight">
                <span className="text-xs font-semibold tracking-widest text-gray-400 uppercase">
                  Official Exam Platform Partner
                </span>
                <span className="text-md font-extrabold text-gray-800 group-hover:text-orange-500 transition-colors">
                  Indolat
                </span>
              </span>
            </a>
          </div>

          {/* Right illustration */}
          <div
            data-aos="fade-left"
            data-aos-delay="200"
            className="flex-1 flex justify-center md:justify-end z-10"
          >
            <div className="relative w-full max-w-[380px]">
              <ArsenHeroSVG width="100%" height="auto" />
              <img
                src="/assets/img/mascot/mascot2.svg"
                alt=""
                className="hidden sm:block absolute bottom-2 -left-16 sm:-left-20 w-20 sm:w-24 h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ── SPONSORSHIP BANNER ── */}
      <div data-aos="fade-up" className="bg-arsen-quaternary-950 py-4 px-5">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white font-semibold text-sm sm:text-base text-center sm:text-left">
            We Are Open for Sponsorship and Media Partner!
          </p>
          <Link
            to="https://wa.me/6281249127845"
            target="_blank"
            className="shrink-0 px-6 py-2 rounded-lg bg-white text-arsen-quaternary-950 text-sm font-bold hover:bg-arsen-sky-100 transition-colors duration-200"
          >
            Hubungi Kami
          </Link>
        </div>
      </div>

      {/* ── ABOUT + GOALS ── */}
      <section
        id="tentang"
        className="max-w-6xl mx-auto w-full px-5 sm:px-8 py-20 grid md:grid-cols-2 gap-16"
      >
        {/* About */}
        <div data-aos="fade-right" className="flex flex-col gap-5">
          <div className="flex items-center gap-3">
            <div className="w-1 h-8 bg-arsen-primary rounded-full" />
            <span className="text-xs font-bold tracking-widest text-gray-400 uppercase">
              Tentang
            </span>
          </div>
          <h2 className="text-3xl font-extrabold text-arsen-quaternary-950 leading-snug">
            Airlangga Statistics Events
          </h2>
          <p className="text-gray-500 text-sm leading-8 text-justify">
            Airlangga Statistics Event (ARSEN) adalah ajang perlombaan bergengsi
            yang diselenggarakan oleh HIMASTA Universitas Airlangga. Pada tahun
            ini ARSEN mengusung tema{" "}
            <span className="font-semibold text-gray-700 italic">
              "Defining Certainty within Global Volatility by Unlocking the
              Trivecta of Data Mastery"
            </span>{" "}
            Kegiatan ini menjadi wadah bagi generasi muda untuk mengembangkan
            kreativitas, inovasi, dan kemampuan berpikir kritis berbasis
            statistika. Kompetisi ARSEN terbuka untuk mahasiswa dari seluruh
            perguruan tinggi di Indonesia serta pelajar SMA/SMK/MA sederajat.
            Tidak hanya perlombaan, ARSEN juga menghadirkan webinar inspiratif
            yang membahas isu-isu aktual di bidang statistika.
          </p>
        </div>

        {/* Goals */}
        <div data-aos="fade-left" className="flex flex-col gap-5">
          <div className="flex items-center gap-3">
            <div className="w-1 h-8 bg-arsen-secondary rounded-full" />
            <span className="text-xs font-bold tracking-widest text-gray-400 uppercase">
              Tujuan
            </span>
          </div>
          <h2 className="text-3xl font-extrabold text-arsen-quaternary-950 leading-snug">
            Tujuan Kegiatan
          </h2>
          <p className="text-gray-400 text-xs mb-1">
            Tujuan program kerja ARSEN 2026 adalah sebagai berikut:
          </p>
          <ol className="flex flex-col gap-3">
            {goals.map((g, i) => (
              <li
                key={i}
                className="flex gap-3 text-sm text-gray-600 leading-relaxed"
              >
                <span className="shrink-0 w-6 h-6 rounded-full bg-arsen-secondary-50 text-arsen-secondary text-xs font-bold flex items-center justify-center mt-0.5">
                  {i + 1}
                </span>
                {g}
              </li>
            ))}
          </ol>
          <p className="text-sm text-gray-500 leading-7 mt-1 pl-9">
            Dengan mencapai tujuan-tujuan tersebut,{" "}
            <span className="font-semibold text-gray-700">ARSEN</span>{" "}
            berkomitmen menjadi ruang inspiratif bagi generasi muda untuk
            berkontribusi dalam mewujudkan masa depan yang lebih adil, inklusif,
            dan berkelanjutan melalui kekuatan data.
          </p>
        </div>
      </section>

      {/* ── LUMI ── */}
      <section className="bg-gradient-to-r from-arsen-primary-50 to-arsen-sky-50 py-16 px-5 sm:px-8">
        <div
          data-aos="fade-up"
          className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10"
        >
          <div className="md:w-64 shrink-0 flex justify-center">
            <img
              src="/assets/img/mascot/mascot2.svg"
              alt="LUMI — Maskot ARSEN"
              className="w-56 h-auto"
            />
          </div>
          <div className="flex flex-col gap-3 text-center md:text-left">
            <span className="text-xs font-bold tracking-widest text-gray-400 uppercase">
              Maskot ARSEN
            </span>
            <h2 className="text-3xl font-extrabold text-arsen-quaternary-950">
              LUMI
            </h2>
            <p className="text-sm text-gray-500 leading-8 max-w-2xl text-justify">
              <span className="font-bold text-gray-700">LUMI</span> adalah
              maskot kucing pemberani dalam perlombaan statistika ARSEN yang
              memulai petualangannya dari dunia yang dipenuhi ketidakpastian dan
              kehilangan cahaya. Dengan jubah berkilau layaknya aurora,{" "}
              <span className="font-bold text-gray-700">LUMI</span> menjelajahi
              semesta mengikuti cahaya bintang sebagai penunjuk jalan. Di
              sepanjang perjalanan, ia menemukan tiga petunjuk penting teleskop,
              kaca pembesar, dan kompas yang melambangkan kemampuan mengamati,
              menganalisis, dan menentukan arah, nilai-nilai utama dalam setiap
              cabang perlombaan ARSEN.
              <br />
              <br />
              Liontin berbentuk bintang di leher{" "}
              <span className="font-bold text-gray-700">LUMI</span> bersinar
              setiap kali ia berhasil menemukan pola di balik ribuan bintang.
              Bagi <span className="font-bold text-gray-700">LUMI</span>, setiap
              bintang adalah data dan setiap pola menghadirkan insight yang
              membawanya menuju tujuan. Berkat kemampuannya mengubah data
              menjadi arah yang pasti,{" "}
              <span className="font-bold text-gray-700">LUMI</span> menemukan
              sebuah planet baru sebagai simbol clarity, tempat ketidakpastian
              berubah menjadi keyakinan. Kisah ini mengingatkan bahwa statistika
              bukan hanya tentang angka, tetapi tentang menemukan makna,
              mengambil keputusan, dan menciptakan kepastian. Karena bagi{" "}
              <span className="font-bold text-gray-700">LUMI</span>, "Every star
              is a step, every step is hope." Let's Start the Magical Adventure!
            </p>
          </div>
        </div>
      </section>

      {/* ── JINGLE ── */}
      <section
        data-aos="fade-up"
        className="max-w-6xl mx-auto w-full px-5 sm:px-8 py-16"
      >
        <div className="flex flex-col items-center gap-4">
          <span className="text-xs font-bold tracking-widest text-gray-400 uppercase">
            Jingle
          </span>
          <h2 className="text-3xl font-extrabold text-arsen-quaternary-950">
            ARSEN
          </h2>
          <div className="w-full max-w-3xl overflow-hidden rounded-2xl shadow-lg">
            <iframe
              className="w-full aspect-video"
              src="https://www.youtube-nocookie.com/embed/kBx8oJZbPEQ?si=WGKgmKgGRuo32kCo&controls=0"
              title="Jingle ARSEN"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      {/* ── ACTIVITY CARDS ── */}
      <section className="bg-gray-50 py-16 px-5 sm:px-8">
        <div className="max-w-6xl mx-auto">
          <div
            data-aos="fade-up"
            className="flex flex-col items-center gap-2 mb-10 text-center"
          >
            <span className="text-xs font-bold tracking-widest text-gray-400 uppercase">
              Jenis Kegiatan
            </span>
            <h2 className="text-3xl font-extrabold text-arsen-quaternary-950">
              Pilih Kompetisimu
            </h2>
            <p className="text-sm text-gray-400 max-w-md">
              Lima cabang kegiatan yang bisa kamu ikuti di ARSEN 2026.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {activities.map((act, i) => (
              <div
                key={act.slug}
                data-aos="fade-up"
                data-aos-delay={i * 60}
                className={`bg-white rounded-2xl shadow-sm border-t-4 ${act.border} flex flex-col p-6 gap-4 hover:shadow-xl transition duration-500 ease-out group`}
              >
                <span
                  className={`self-start text-[10px] font-bold tracking-widest px-2.5 py-1 rounded-full uppercase ${act.tag}`}
                >
                  {act.label}
                </span>
                <div className="flex flex-col gap-1.5 flex-1">
                  <h3 className="text-xl font-extrabold text-arsen-quaternary-950">
                    {act.name}
                  </h3>
                  <p className="text-sm text-gray-400 leading-relaxed">
                    {act.description}
                  </p>
                </div>
                <Link
                  to={`/${act.slug}`}
                  onClick={() => window.scrollTo(0, 0)}
                  className={`self-start flex items-center gap-1.5 text-xs font-bold px-4 py-2 rounded-lg border transition-all duration-200 hover:text-white hover:shadow-md ${act.cta} border-current`}
                >
                  Detail Kegiatan
                  <svg
                    className="w-3 h-3 group-hover:translate-x-0.5 transition-transform"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2.5}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
